import { render } from "./prompts-banner.vue?vue&type=template&id=502246fe&lang=pug"
import script from "./prompts-banner.vue?vue&type=script&lang=js"
export * from "./prompts-banner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__